import { ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import {
    Contract,
    DomainPrice,
    GetProductByGroupNameResponse,
    ProductResponse,
} from '../types'

export const createCustomerContract = async (values: Contract) => {
    const response = await datacentral.post(`/contracts/customers`, {
        ...values,
    })

    return response?.data
}

const UNAVAILABLE_SERVICE_POC = [
    'DOMAIN',
    'SSL',
    'DEVICE LIQUIDATION',
    'OTHER',
    'KHÁC',
    'KHAC',
]
// "Other/Khác" service group is restricted: only users allowed to manage the Other-service
// flow (Admin, or the Sale/CSKH/BOM roles that can write customers) may pick it in a contract.
const RESTRICTED_SERVICE_GROUPS = ['OTHER', 'KHÁC', 'KHAC']

export const getServiceInteresting = async (
    customer_id: number,
    isPOC?: boolean,
    canSelectOtherGroups = false
) => {
    const response = await datacentral.get<ResponseArray<string>>(
        `/customers/${customer_id}/service-interestings`
    )

    if (!response?.data?.results) return []

    return response?.data?.results
        ?.filter((item) => {
            const normalizedItem = item?.toUpperCase?.() || item
            if (isPOC) {
                return !UNAVAILABLE_SERVICE_POC.includes(normalizedItem)
            }
            if (!canSelectOtherGroups) {
                return !RESTRICTED_SERVICE_GROUPS.includes(normalizedItem)
            }
            return true
        })
        .map((item) => ({
            label: item,
            value: item,
        }))
}

export const getProductByGroupName = async ({
    group_name,
    is_addon,
}: {
    group_name: string
    is_addon: boolean
}) => {
    const response = await datacentral.get<
        ResponseArray<GetProductByGroupNameResponse>
    >(`/products/groups?group_name=${group_name}&is_addon=${is_addon}`)
    return response?.data
}

export const getProductById = async (product_id: number) => {
    const response = await datacentral.get<ResponseObject<ProductResponse>>(
        `/products/${product_id}`
    )
    return response?.data
}

export const getDomainPrices = async () => {
    const response = await datacentral.get<ResponseArray<DomainPrice>>(
        `/products/domain-prices`
    )
    return response?.data
}

export interface CreateOtherProductPayload {
    product_name: string
    product_code?: string
    product_description?: string
    product_hidden?: boolean
    price?: number
    currency?: string
    start_date?: string
    end_date?: string | null
}

export interface CreateOtherProductResult {
    product: ProductResponse
    price?: {
        product_price_id: number
        product_id: number
        price: number
        start_date: string
        end_date: string | null
        currency: string
    }
}

export const createOtherProduct = async (
    payload: CreateOtherProductPayload
) => {
    const response = await datacentral.post<
        ResponseObject<CreateOtherProductResult>
    >('/products/other', payload)
    return response.data.result
}
